"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e = require("react"),
  r = require("react-element-popper"),
  t = require("react-date-object");
function n(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}
var a = n(e),
  o = n(r),
  i = n(t);
function d(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function l(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? d(Object(t), !0).forEach(function (r) {
      u(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : d(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function u(e, r, t) {
  return (r = function (e) {
    var r = function (e, r) {
      if ("object" != typeof e || null === e) return e;
      var t = e[Symbol.toPrimitive];
      if (void 0 !== t) {
        var n = t.call(e, r || "default");
        if ("object" != typeof n) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof r ? r : String(r);
  }(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function c() {
  return c = Object.assign ? Object.assign.bind() : function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, c.apply(this, arguments);
}
function s(e, r) {
  if (null == e) return {};
  var t,
    n,
    a = function (e, r) {
      if (null == e) return {};
      var t,
        n,
        a = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++) t = o[n], r.indexOf(t) >= 0 || (a[t] = e[t]);
      return a;
    }(e, r);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (n = 0; n < o.length; n++) t = o[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
  }
  return a;
}
function f(e, r) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, r) {
    var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != t) {
      var n,
        a,
        o,
        i,
        d = [],
        l = !0,
        u = !1;
      try {
        if (o = (t = t.call(e)).next, 0 === r) {
          if (Object(t) !== t) return;
          l = !1;
        } else for (; !(l = (n = o.call(t)).done) && (d.push(n.value), d.length !== r); l = !0);
      } catch (e) {
        u = !0, a = e;
      } finally {
        try {
          if (!l && null != t.return && (i = t.return(), Object(i) !== i)) return;
        } finally {
          if (u) throw a;
        }
      }
      return d;
    }
  }(e, r) || m(e, r) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function p(e) {
  return function (e) {
    if (Array.isArray(e)) return h(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || m(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function m(e, r) {
  if (e) {
    if ("string" == typeof e) return h(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? h(e, r) : void 0;
  }
}
function h(e, r) {
  (null == r || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++) n[t] = e[t];
  return n;
}
function y(e, r) {
  var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (!t) {
    if (Array.isArray(e) || (t = m(e)) || r && e && "number" == typeof e.length) {
      t && (e = t);
      var n = 0,
        a = function () {};
      return {
        s: a,
        n: function () {
          return n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[n++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: a
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    i = !0,
    d = !1;
  return {
    s: function () {
      t = t.call(e);
    },
    n: function () {
      var e = t.next();
      return i = e.done, e;
    },
    e: function (e) {
      d = !0, o = e;
    },
    f: function () {
      try {
        i || null == t.return || t.return();
      } finally {
        if (d) throw o;
      }
    }
  };
}
function g(e) {
  return Array.isArray(e);
}
function v(r) {
  var t = r.state.date,
    n = t.calendar,
    o = t.locale,
    d = r.customWeekDays,
    l = r.weekStartDayIndex,
    u = r.displayWeekNumbers,
    c = r.weekNumber,
    s = e.useMemo(function () {
      var e = d;
      return g(e) && e.length >= 7 ? (e.length = 7, e = e.map(function (e) {
        return g(e) & e.length > 1 ? e = e[1] : g(e) && (e = e[0]), e;
      })) : e = new i.default({
        year: 1,
        calendar: n,
        locale: o
      }).weekDays.map(function (e) {
        return e.shortName;
      }), e;
    }, [n, o, d]);
  return s = p(s).slice(l).concat(p(s).splice(0, l)), a.default.createElement("div", {
    className: "rmdp-week"
  }, u && a.default.createElement("div", {
    className: "rmdp-week-day"
  }, c), s.map(function (e, r) {
    return a.default.createElement("div", {
      key: r,
      className: "rmdp-week-day"
    }, e);
  }));
}
function b(e, r) {
  var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
    n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
  if (!e || !r) return !1;
  if (e.year === r.year) {
    if (n) return !0;
    if (e.monthIndex === r.monthIndex) return !!t || e.day === r.day;
  }
}
function x(e) {
  var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "YYYY/MM/DD";
  return e.format(r);
}
function w(e, r, t) {
  var n = t.multiple,
    a = t.range,
    o = t.selectedDate,
    d = t.onlyMonthPicker,
    l = t.onlyYearPicker,
    u = t.format,
    c = t.focused,
    s = t.weekPicker;
  e.setFormat(u);
  var m = new i.default(e);
  return o = n && a ? function () {
    var e = !0;
    g(o) || (o = [[o]]);
    var r = o.find(function (e) {
        return 1 === e.length;
      }),
      t = d ? "YYYY/MM" : "YYYY/MM/DD",
      n = o;
    if (r) {
      var a = r[0];
      n = n.filter(function (e) {
        if (1 === e.length) return !0;
        var r = f(e, 2),
          n = r[0],
          o = r[1],
          i = f([a, m].sort(function (e, r) {
            return e - r;
          }), 2),
          d = [n, o, i[0], i[1]].map(function (e) {
            return x(e, t);
          }),
          l = f(d, 4),
          u = l[0],
          c = l[1],
          s = l[2],
          p = l[3];
        return !(s <= u && p >= c || s >= u && p >= c && s <= c || s <= u && p <= c && p >= u);
      });
    } else n = n.filter(function (e) {
      if (!g(e)) return !0;
      if (0 === e.length) return !1;
      var r = f(e, 2),
        n = [r[0], r[1], m].map(function (e) {
          return x(e, t);
        }),
        a = f(n, 3),
        o = a[0],
        i = a[1],
        d = a[2];
      return !(d >= o && d <= i);
    });
    n = n.map(function (r) {
      var t;
      return g(r) ? 1 === r.length ? (e = !1, t = r.concat(m)) : t = r : (e = !1, t = [r, m]), t.sort(function (e, r) {
        return e - r;
      });
    }), e && (n = [].concat(p(n), [[m]]));
    return n;
  }() : n ? function () {
    var t = o.filter(function (r) {
      return !b(e, r, d, l);
    });
    t.length === o.length ? t.push(m) : m = t.find(function (e) {
      return b(e, c);
    });
    r && t.sort(function (e, r) {
      return e - r;
    });
    return t;
  }() : a ? function () {
    if (s) return [new i.default(m).toFirstOfWeek(), new i.default(m).toLastOfWeek()];
    if (2 === o.length || 0 === o.length) return [m];
    if (1 === o.length) return [o[0], m].sort(function (e, r) {
      return e - r;
    });
  }() : m, [o, m];
}
function k(e, r, t, n) {
  var a = [],
    o = t ? "YYYY/MM" : "YYYY/MM/DD",
    i = x(e, o);
  function d(r) {
    var n = r[0],
      d = r[1];
    if (1 === r.length) b(e, n, t) && a.push("rmdp-range");else if (2 === r.length) {
      var l = [n, d].map(function (e) {
          return x(e, o);
        }),
        u = f(l, 2),
        c = u[0],
        s = u[1];
      i >= c && i <= s && a.push("rmdp-range"), i === c && a.push("start"), i === s && a.push("end");
    }
  }
  return n ? (g(r) ? r : [[r]]).forEach(d) : d(r), a.join(" ");
}
function D(e, r, t, n) {
  var a = arguments.length > 5 ? arguments[5] : void 0,
    o = [];
  if (n && t) {
    var i,
      d = "day" === (arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "day") ? "YYYY/MM/DD" : "YYYY/MM",
      l = t.format(d),
      u = e.format(d);
    if (a || 1 !== (null == r ? void 0 : r.length)) {
      if (a && g(r)) {
        var c,
          s = y(r);
        try {
          for (s.s(); !(c = s.n()).done;) {
            var f = c.value;
            if (g(f) && 1 === f.length) {
              i = f[0].format(d);
              break;
            }
          }
        } catch (e) {
          s.e(e);
        } finally {
          s.f();
        }
      }
    } else i = r[0].format(d);
    (u > i && u <= l || u < i && u >= l) && (o.push("rmdp-range-hover"), u === l && o.push(l > i ? "end" : "start"), g(r) && r.flat().some(function (e) {
      return e.format(d) === u;
    }) && o.push("force"));
  }
  return o;
}
var O,
  E = "dddd MMMM DD of YYYY";
function Y(r) {
  var t = r.state,
    n = r.setState,
    o = r.onChange,
    d = r.showOtherDays,
    s = void 0 !== d && d,
    p = r.mapDays,
    m = r.onlyShowInRangeDates,
    h = r.customWeekDays,
    y = r.sort,
    g = r.numberOfMonths,
    x = r.isRTL,
    Y = r.weekStartDayIndex,
    M = r.handleFocusedDate,
    P = r.hideWeekDays,
    N = r.fullYear,
    S = f(r.monthAndYears, 1)[0],
    C = r.displayWeekNumbers,
    I = r.weekNumber,
    j = void 0 === I ? "" : I,
    T = r.rangeHover,
    A = r.highlightToday,
    R = e.useRef({}),
    L = e.useRef(),
    F = t.today,
    V = t.minDate,
    W = t.maxDate,
    B = t.range,
    _ = t.multiple,
    z = t.date,
    H = t.selectedDate,
    q = t.onlyMonthPicker,
    J = t.onlyYearPicker,
    K = !q && !J,
    U = f(e.useState(), 2),
    $ = U[0],
    G = U[1],
    Q = _ || B ? (null == H ? void 0 : H.length) > 0 : !!H;
  R.current.date = z;
  var X = e.useMemo(function () {
    return K ? function (e, r, t, n) {
      if (!e) return [];
      for (var a = [], o = 0; o < t; o++) {
        var d = (e = new i.default(e).toFirstOfMonth()).monthIndex,
          l = [];
        e.toFirstOfWeek().add(n, "day"), e.monthIndex === d && e.day > 1 && e.subtract(7, "days");
        for (var u = 0; u < 6; u++) {
          for (var c = [], s = 0; s < 7; s++) c.push({
            date: new i.default(e),
            day: e.format("D"),
            current: e.monthIndex === d
          }), e.day += 1;
          if (l.push(c), u > 2 && e.monthIndex !== d && !r) break;
        }
        a.push(l);
      }
      return a;
    }(R.current.date, s, g, Y) : [];
  }, [z.monthIndex, z.year, z.calendar, z.locale, K, s, g, Y]);
  return K && a.default.createElement("div", {
    ref: L,
    className: "rmdp-day-picker ".concat(N ? "rmdp-full-year" : ""),
    style: {
      display: N ? "grid" : "flex"
    },
    onMouseLeave: function () {
      return T && G();
    }
  }, X.map(function (e, r) {
    return a.default.createElement("div", {
      key: r,
      style: u({}, x ? "marginLeft" : "marginRight", r + (N ? 0 : 1) < g ? "10px" : "")
    }, N && a.default.createElement("div", {
      className: "rmdp-month-name"
    }, S[r]), !P && a.default.createElement(v, {
      state: t,
      customWeekDays: h,
      weekStartDayIndex: Y,
      displayWeekNumbers: C,
      weekNumber: j
    }), e.map(function (e, d) {
      return a.default.createElement("div", {
        key: d,
        className: "rmdp-week"
      }, C && a.default.createElement("div", {
        className: "rmdp-day rmdp-disabled"
      }, a.default.createElement("span", null, e[0].date.format("WW"))), e.map(function (e, d) {
        var u = function (e) {
            if (!e.current && !s) return {};
            var r = {};
            return p.forEach(function (n) {
              var a,
                o = n({
                  date: e.date,
                  today: F,
                  currentMonth: t.date.month,
                  selectedDate: t.selectedDate,
                  isSameDate: b
                });
              (null === (a = o) || void 0 === a ? void 0 : a.constructor) !== Object && (o = {}), (o.disabled || o.hidden) && (e.disabled = !0), o.hidden && (e.hidden = !0), r = l(l({}, r), o);
            }), delete r.disabled, delete r.hidden, r;
          }(e = {
            date: e.date,
            day: e.day,
            current: e.current
          }),
          h = Z(e) && !e.disabled,
          v = "".concat(h ? "sd" : ""),
          x = u.children;
        h && (v = "".concat(v, " ").concat(u.className || "")), delete u.className, delete u.children;
        var Y = function (e, r) {
          var t = ["rmdp-day"],
            n = e.date,
            a = e.hidden,
            o = e.current;
          if (!Z(e) || a) t.push("rmdp-day-hidden");else {
            (V && n < V || W && n > W || e.disabled) && (t.push("rmdp-disabled"), e.disabled || (e.disabled = !0)), o || t.push("rmdp-deactive");
            var i = r > 1 && o || 1 === r;
            e.disabled && m || (b(n, F) && A && t.push("rmdp-today"), d = n, [].concat(H).some(function (e) {
              return b(e, d);
            }) && i && !B && t.push("rmdp-selected")), B && !e.disabled && i && (t.push(k(n, H, void 0, _)), t = t.concat(D(n, H, $, T, void 0, _)));
          }
          var d;
          return t.join(" ");
        }(e, g);
        (e.hidden || e.disabled) && (v = v.replace("sd", ""));
        var P = Q ? Y.includes("selected") || Y.includes("range") : Y.includes("today");
        return a.default.createElement("div", {
          key: d,
          tabIndex: P ? 0 : -1,
          "aria-label": "Choose ".concat(e.date.format(E)),
          className: Y,
          onMouseEnter: function () {
            return T && G(e.date);
          },
          onKeyDown: function (r) {
            return function (e, r) {
              var a = e.currentTarget,
                o = e.key,
                d = e.code,
                u = {
                  ArrowRight: 1,
                  ArrowLeft: -1,
                  ArrowUp: -7,
                  ArrowDown: 7
                };
              if ("Space" === d || " " === o) e.preventDefault(), a.click();else if (Object.keys(u).includes(o)) {
                var c = function (e) {
                    if (!e) return s();
                    var r = e.getAttribute("class");
                    r.includes("hidden") || r.includes("disabled") ? s() : e.focus();
                  },
                  s = function () {
                    n(l(l({}, t), {}, {
                      date: p
                    })), clearTimeout(O), O = setTimeout(function () {
                      return c(ee(p));
                    }, 100);
                  };
                e.preventDefault();
                var f = u[o],
                  p = new i.default(r.date).add(f, "day"),
                  m = ee(p);
                c(m);
              }
            }(r, e);
          },
          onClick: function () {
            Z(e) && !e.disabled && function (e, r, n) {
              var a,
                d,
                u,
                c = e.date,
                s = e.current,
                p = t.selectedDate,
                m = t.focused,
                h = t.date,
                g = h,
                v = g.hour,
                b = g.minute,
                x = g.second;
              c.set({
                hour: (null === (a = p) || void 0 === a ? void 0 : a.hour) || v,
                minute: (null === (d = p) || void 0 === d ? void 0 : d.minute) || b,
                second: (null === (u = p) || void 0 === u ? void 0 : u.second) || x
              }), 1 !== n || s ? n > 1 && !s && (0 === r && c < h && (h = new i.default(h).toFirstOfMonth()), r > 0 && c.monthIndex > h.monthIndex + r && r + 1 === n && (h = new i.default(h).toFirstOfMonth().add(1, "month"))) : h = new i.default(h).toFirstOfMonth();
              var k = f(w(c, y, t), 2);
              p = k[0], m = k[1], o(p, l(l({}, t), {}, {
                date: h,
                focused: m,
                selectedDate: p
              })), M(m, c);
            }(e, r, g);
          }
        }, a.default.createElement("span", c({
          className: v
        }, u), Z(e) && !e.hidden ? null != x ? x : e.day : ""));
      }));
    }));
  }));
  function Z(e) {
    return !!e.current || s;
  }
  function ee(e) {
    return L.current.querySelector("[aria-label*='".concat(e.format(E), "']"));
  }
}
function M(e) {
  var r = e.direction,
    t = e.onClick,
    n = e.disabled;
  return a.default.createElement("button", {
    type: "button",
    className: "rmdp-arrow-container ".concat(r, " ").concat(n ? "disabled" : ""),
    onClick: t,
    "aria-roledescription": "button to navigate ".concat(r.replace("rmdp-", ""))
  }, a.default.createElement("i", {
    className: "rmdp-arrow"
  }));
}
function P(r) {
  var t = r.state,
    n = r.setState,
    o = r.disableYearPicker,
    i = r.disableMonthPicker,
    d = r.buttons,
    u = r.renderButton,
    c = r.handleMonthChange,
    s = r.disabled,
    p = r.hideMonth,
    m = r.hideYear,
    h = r.isRTL,
    y = r.fullYear,
    g = f(r.monthAndYears, 2),
    v = g[0],
    b = g[1],
    x = r.monthYearSeparator,
    w = r.formatMonth,
    k = r.formatYear,
    D = r.headerOrder,
    O = {},
    E = t.date,
    Y = t.onlyMonthPicker,
    P = t.onlyYearPicker,
    N = t.mustShowYearPicker,
    S = t.minDate,
    C = t.maxDate,
    I = t.year,
    j = t.today,
    T = S && E.year <= S.year && S.monthIndex > E.monthIndex - 1,
    A = C && E.year >= C.year && C.monthIndex < E.monthIndex + 1,
    R = j.year + 7;
  if (R -= 12 * Math.floor((R - I) / 12), (p || y) && m && !d) return null;
  if ((Y || y) && (S && S.year >= E.year && (T = !0), C && C.year <= E.year && (A = !0)), N || P) {
    var L = R - 11;
    T = S && S.year > L, A = C && C.year < R;
  }
  return s && (T = !0, A = !0), a.default.createElement("div", {
    className: "rmdp-header"
  }, a.default.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      alignItems: "center"
    }
  }, Array.from(new Set(D)).map(function (r, t) {
    return a.default.createElement(e.Fragment, {
      key: t
    }, function (r) {
      switch (r) {
        case "LEFT_BUTTON":
          return d && V("left");
        case "RIGHT_BUTTON":
          return d && V("right");
        case "MONTH_YEAR":
        case "YEAR_MONTH":
          if (y) return a.default.createElement("div", {
            className: "rmdp-header-values",
            style: O
          }, !m && E.format("YYYY"));
          var t = r.split("_").filter(function (e) {
            return "MONTH" === e && !p || "YEAR" === e && !m;
          });
          return t.length > 1 && (t = [t[0], F(), t[1]]), v.map(function (r, n) {
            return a.default.createElement("div", {
              key: n,
              className: "rmdp-header-values",
              style: O
            }, t.map(function (t, d) {
              return a.default.createElement(e.Fragment, {
                key: d
              }, function (e, r, t) {
                switch (e) {
                  case "MONTH":
                    return a.default.createElement("span", {
                      style: {
                        cursor: s || i || Y ? "default" : "pointer"
                      },
                      onClick: function () {
                        return !i && B("mustShowMonthPicker");
                      }
                    }, function (e, r) {
                      return "function" == typeof w ? w(e, r) : e;
                    }(r, b[t]));
                  case "YEAR":
                    return a.default.createElement("span", {
                      style: {
                        cursor: s || o || P ? "default" : "pointer"
                      },
                      onClick: function () {
                        return !o && B("mustShowYearPicker");
                      }
                    }, function (e, r) {
                      return "function" == typeof w ? k(e, r) : e;
                    }(b[t], r));
                  default:
                    return e;
                }
              }(t, r, n));
            }));
          });
        default:
          return;
      }
    }(r));
  })));
  function F() {
    return x ? a.default.createElement("span", null, x) : h ? "،" : ",";
  }
  function V(r) {
    var t = function (e) {
        e.preventDefault(), W("right" === r ? 1 : -1), function (e) {
          setTimeout(function () {
            var r = e.target.closest(".rmdp-calendar");
            if (r) {
              var t = r.querySelector("div[tabindex='0']");
              t && t.getAttribute("class").includes("hidden") && (t.setAttribute("tabindex", "-1"), t = void 0), t || (t = r.querySelector("div[tabindex='-1']:not(.rmdp-day-hidden)")) && t.setAttribute("tabindex", "0");
            }
          }, 200);
        }(e);
      },
      n = "left" === r && T || "right" === r && A;
    return u instanceof Function ? u(r, t, n) : e.isValidElement(u) ? e.cloneElement(u, {
      direction: r,
      handleClick: t,
      disabled: n
    }) : a.default.createElement(M, {
      direction: "rmdp-".concat(r),
      onClick: t,
      disabled: n
    });
  }
  function W(e) {
    s || e < 0 && T || e > 0 && A || (y ? E.year += e : N || P ? (I += 12 * e, e < 0 && S && I < S.year && (I = S.year), e > 0 && C && I > C.year && (I = C.year)) : (E.toFirstOfMonth(), Y ? E.year += e : (E.month += e, c(E))), n(l(l({}, t), {}, {
      date: E,
      year: I
    })));
  }
  function B(e) {
    if (!s) {
      var r = {
        mustShowMonthPicker: !1,
        mustShowYearPicker: !1
      };
      r[e] = !t[e], n(l(l({}, t), r));
    }
  }
}
function N(e) {
  return g(e) || (e = []), JSON.stringify(e);
}
function S(r) {
  var t = r.state,
    n = r.onChange,
    o = r.customMonths,
    d = r.sort,
    u = r.handleMonthChange,
    c = r.handleFocusedDate,
    s = r.rangeHover,
    p = r.highlightToday,
    m = r.numberOfMonths,
    h = t.date,
    y = t.today,
    v = t.minDate,
    x = t.maxDate,
    O = t.calendar,
    E = t.locale,
    Y = t.onlyMonthPicker,
    M = t.onlyYearPicker,
    P = t.range,
    S = t.onlyShowInRangeDates,
    C = (t.mustShowMonthPicker || Y) && !M,
    I = f(e.useState(), 2),
    j = I[0],
    T = I[1];
  o = o && N(o);
  var A = e.useMemo(function () {
    var e = [],
      r = Y ? m : 1,
      n = o && JSON.parse(o),
      a = new i.default({
        calendar: O,
        locale: E,
        format: t.date._format,
        year: t.date.year,
        month: 1,
        day: 1
      });
    g(n) && n.length >= 12 ? (n.length = 12, n = n.map(function (e) {
      return g(e) ? e[0] : e;
    })) : n = a.locale.months.map(function (e) {
      return f(e, 1)[0];
    });
    for (var d = 0; d < r; d++) {
      for (var l = [], u = 0, c = 0; c < 4; c++) {
        for (var s = [], p = 0; p < 3; p++) s.push({
          date: new i.default(a),
          name: n[u]
        }), u++, a.add(1, "month");
        l.push(s);
      }
      e.push(l);
    }
    return e;
  }, [O, E, o, t.date.year, t.date._format, m, Y]);
  return a.default.createElement("div", {
    className: "".concat(Y ? "only " : "", "rmdp-month-picker"),
    style: {
      display: C ? "flex" : "none"
    },
    onMouseLeave: function () {
      return s && T();
    }
  }, A.map(function (e, r) {
    return a.default.createElement("div", {
      key: r,
      style: {
        margin: "0 5px",
        flex: 1
      }
    }, e.map(function (e, r) {
      return a.default.createElement("div", {
        key: r,
        className: "rmdp-ym"
      }, e.map(function (e, r) {
        var t = e.date,
          n = e.name;
        return a.default.createElement("div", {
          key: r,
          className: L(t),
          onClick: function () {
            return R(t);
          },
          onMouseEnter: function () {
            return s && T(t);
          }
        }, a.default.createElement("span", {
          className: Y ? "sd" : ""
        }, n));
      }));
    }));
  }));
  function R(e) {
    var r = t.selectedDate,
      a = t.focused,
      o = e.year,
      i = e.monthIndex;
    if (!(v && o <= v.year && i < v.monthIndex || x && o >= x.year && i > x.monthIndex)) {
      if (h.setMonth(i + 1), Y) {
        var s = f(w(e, d, t), 2);
        r = s[0], a = s[1];
      } else u(h);
      n(Y ? r : void 0, l(l({}, t), {}, {
        date: h,
        focused: a,
        selectedDate: r,
        mustShowMonthPicker: !1
      })), Y && c(a, e);
    }
  }
  function L(e) {
    var r = ["rmdp-day"],
      n = e.year,
      a = e.monthIndex,
      o = t.selectedDate,
      i = t.multiple;
    if ((v && (n < v.year || n === v.year && a < v.monthIndex) || x && (n > x.year || n === x.year && a > x.monthIndex)) && r.push("rmdp-disabled"), !r.includes("rmdp-disabled") || !S) return b(y, e, !0) && p && r.push("rmdp-today"), Y ? P ? (r.push(k(e, o, !0, i)), r = r.concat(D(e, o, j, s, "month", i))) : [].concat(o).some(function (r) {
      return b(r, e, !0);
    }) && r.push("rmdp-selected") : h.monthIndex === a && r.push("rmdp-selected"), r.join(" ");
  }
}
function C(e, r) {
  return e.replace(/[0-9]/g, function (e) {
    return r[e];
  });
}
function I(r) {
  var t = r.state,
    n = r.onChange,
    o = r.sort,
    d = r.handleFocusedDate,
    u = r.onYearChange,
    c = r.rangeHover,
    s = r.highlightToday,
    p = t.date,
    m = t.today,
    h = t.minDate,
    y = t.maxDate,
    v = t.onlyYearPicker,
    b = t.range,
    x = t.onlyShowInRangeDates,
    k = t.year,
    D = t.mustShowYearPicker || v,
    O = p.digits,
    E = f(e.useState(), 2),
    Y = E[0],
    M = E[1],
    P = m.year - 4;
  P -= 12 * Math.ceil((P - k) / 12);
  var N = e.useMemo(function () {
    for (var e = [], r = P, t = 0; t < 4; t++) {
      for (var n = [], a = 0; a < 3; a++) n.push(r), r++;
      e.push(n);
    }
    return e;
  }, [P]);
  return a.default.createElement("div", {
    className: "".concat(v ? "only " : "", "rmdp-year-picker"),
    style: {
      display: D ? "block" : "none"
    }
  }, N.map(function (e, r) {
    return a.default.createElement("div", {
      key: r,
      className: "rmdp-ym",
      onMouseLeave: function () {
        return c && M();
      }
    }, e.map(function (e, r) {
      return a.default.createElement("div", {
        key: r,
        className: S(e),
        onClick: function () {
          return function (e) {
            if (I(e)) return;
            var r = new i.default(t.date).setYear(e),
              a = t.selectedDate,
              c = t.focused;
            if (v) {
              var s = f(w(r, o, t), 2);
              a = s[0], c = s[1];
            } else h && r.monthIndex < h.monthIndex ? r = r.setMonth(h.monthIndex + 1) : y && r.monthIndex > y.monthIndex && (r = r.setMonth(y.monthIndex + 1)), null == u || u(r);
            n(v ? a : void 0, l(l({}, t), {}, {
              date: r,
              focused: c,
              selectedDate: a,
              mustShowYearPicker: !1
            })), v && d(c, r);
          }(e);
        },
        onMouseEnter: function () {
          return c && M(e);
        }
      }, a.default.createElement("span", {
        className: v ? "sd" : ""
      }, C(e.toString(), O)));
    }));
  }));
  function S(e) {
    var r = ["rmdp-day"],
      n = t.date,
      a = t.selectedDate,
      o = t.multiple;
    if (I(e) && r.push("rmdp-disabled"), !r.includes("rmdp-disabled") || !x) {
      if (m.year === e && s && r.push("rmdp-today"), v) {
        if (b) {
          var i = function (t) {
            var n = t[0],
              a = t[1];
            if (1 === t.length) {
              if (e === n.year && r.push("rmdp-range"), c) {
                var o = t[0].year;
                (e > o && e <= Y || e < o && e >= Y) && (r.push("rmdp-range-hover"), e === Y && r.push(Y > o ? "end" : "start"));
              }
            } else 2 === t.length && (e >= n.year && e <= a.year && r.push("rmdp-range"), e === n.year && r.push("start"), e === a.year && r.push("end"));
          };
          o ? (g(a) ? a : [[a]]).forEach(function (e) {
            return i(e);
          }) : i(a);
        } else [].concat(a).some(function (r) {
          return r && r.year === e;
        }) && r.push("rmdp-selected");
      } else e === n.year && r.push("rmdp-selected");
      return r.join(" ");
    }
  }
  function I(e) {
    return h && e < h.year || y && e > y.year;
  }
}
function j(e, r, t) {
  return t || (e ? "MM/YYYY" : r ? "YYYY" : "YYYY/MM/DD");
}
function T(e, r) {
  var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "YYYY/MM/DD";
  return e instanceof i.default ? e.set({
    calendar: r,
    format: t
  }) : e = new i.default({
    date: e,
    calendar: r,
    format: t
  }), e;
}
function A(e) {
  "_self" in a.default.createElement("div") && console.warn(e.join("\n"));
}
var R = new i.default(),
  L = R.calendar,
  F = R.locale;
function V(e, r) {
  return e && e.constructor !== Object && (A(W("calendar")), e = void 0), r && r.constructor !== Object && (A(W("locale")), r = void 0), [e || L, r || F];
}
function W(e) {
  return ["".concat(e, " must be an object"), "https://shahabyazdi.github.io/react-multi-date-picker/calendars/"];
}
function B(e) {
  return e && e.name ? e.name.split("_")[1] : "";
}
function _(e) {
  return ["fa", "ar"].includes(B(e));
}
function z(e, r) {
  void 0 === r && (r = {});
  var t = r.insertAt;
  if (e && "undefined" != typeof document) {
    var n = document.head || document.getElementsByTagName("head")[0],
      a = document.createElement("style");
    a.type = "text/css", "top" === t && n.firstChild ? n.insertBefore(a, n.firstChild) : n.appendChild(a), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e));
  }
}
z(".rmdp-wrapper{background-color:#fff;border-radius:5px;direction:ltr;text-align:center;width:max-content}.rmdp-shadow{box-shadow:0 0 5px #8798ad}.rmdp-border{border:1px solid #cfd8e2}.rmdp-calendar{height:max-content;padding:4px}.rmdp-border-top{border-top:1px solid #cfd8e2}.rmdp-border-bottom{border-bottom:1px solid #cfd8e2}.rmdp-border-left{border-left:1px solid #cfd8e2}.rmdp-border-right{border-right:1px solid #cfd8e2}.rmdp-week,.rmdp-ym{display:flex;justify-content:space-between}.rmdp-ym{height:25%}.rmdp-day,.rmdp-week-day{color:#000;cursor:pointer;height:34px;position:relative;width:34px}.rmdp-week-day{color:#0074d9;cursor:default;font-size:13px;font-weight:500}.rmdp-day span,.rmdp-week-day{display:flex;flex-direction:column;justify-content:center}.rmdp-day span{border-radius:50%;bottom:3px;font-size:14px;left:3px;position:absolute;right:3px;top:3px}.rmdp-day.rmdp-today span{background-color:#7fdbff;color:#fff}.rmdp-day.rmdp-selected span:not(.highlight){background-color:#0074d9;box-shadow:0 0 3px #8798ad;color:#fff}.rmdp-day.rmdp-deactive,.rmdp-day.rmdp-disabled{color:#8798ad}.rmdp-day.rmdp-deactive.rmdp-selected span{background-color:#4ca6f5;box-shadow:0 0 3px #bac5d3}.rmdp-ym .rmdp-day{flex:1;margin:auto}.rmdp-ym .rmdp-day span{border-radius:12px;padding:2px 0}.rmdp-range{background-color:#0074d9;box-shadow:0 0 3px #8798ad;color:#fff}.rmdp-range-hover{background-color:#7ea6f0;color:#fff}.rmdp-range-hover.start:not(.force),.rmdp-range.start:not(.force){border-bottom-left-radius:50%;border-top-left-radius:50%}.rmdp-range-hover.end:not(.force),.rmdp-range.end:not(.force){border-bottom-right-radius:50%;border-top-right-radius:50%}.rmdp-ym .rmdp-range-hover.start:not(.force),.rmdp-ym .rmdp-range.start:not(.force){border-bottom-left-radius:15px;border-top-left-radius:15px}.rmdp-ym .rmdp-range-hover.end:not(.force),.rmdp-ym .rmdp-range.end:not(.force){border-bottom-right-radius:15px;border-top-right-radius:15px}@media (hover:hover){.rmdp-day:not(.rmdp-disabled,.rmdp-day-hidden) span:hover{background-color:#7ea6f0;color:#fff}}.rmdp-day-picker{padding:5px}.rmdp-header{font-size:14px;margin-top:5px;padding:9px 0}.rmdp-month-picker,.rmdp-year-picker{background-color:#fff;border-radius:0 0 5px 5px;bottom:2px;left:2px;position:absolute;right:2px;top:2px}.only.rmdp-month-picker,.only.rmdp-year-picker{height:240px;position:static;width:240px}.rmdp-header-values{color:#000;margin:auto}.rmdp-header-values span{padding:0 0 0 5px}.rmdp-arrow{border:solid #0074d9;border-width:0 2px 2px 0;display:inline-block;height:3px;margin-top:5px;padding:2px;width:3px}.rmdp-right i{margin-right:3px;transform:rotate(-45deg);-webkit-transform:rotate(-45deg)}.rmdp-left i{margin-left:3px;transform:rotate(135deg);-webkit-transform:rotate(135deg)}.rmdp-left{left:0}.rmdp-right{right:0}.rmdp-arrow-container{background:transparent;border:none;border-radius:50%;cursor:pointer;display:flex;height:20px;justify-content:center;margin:0 5px;padding:0;width:20px}.rmdp-arrow-container:hover{background-color:#0074d9;box-shadow:0 0 3px #8798ad}.rmdp-arrow-container:hover .rmdp-arrow{border:solid #fff;border-width:0 2px 2px 0}.rmdp-arrow-container.disabled{cursor:default}.rmdp-arrow-container.disabled:hover{background-color:inherit;box-shadow:inherit}.rmdp-arrow-container.disabled .rmdp-arrow,.rmdp-arrow-container.disabled:hover .rmdp-arrow{border:solid gray;border-width:0 2px 2px 0}.rmdp-rtl{direction:rtl}.rmdp-rtl .rmdp-left i{margin-left:0;margin-right:3px;transform:rotate(-45deg);-webkit-transform:rotate(-45deg)}.rmdp-rtl .rmdp-right i{margin-left:3px;margin-right:0;transform:rotate(135deg);-webkit-transform:rotate(135deg)}.rmdp-rtl .rmdp-right{left:0;right:auto}.rmdp-rtl .rmdp-left{left:auto;right:0}.rmdp-rtl .rmdp-range-hover.start:not(.force),.rmdp-rtl .rmdp-range.start:not(.force){border-bottom-left-radius:unset;border-bottom-right-radius:50%;border-top-left-radius:unset;border-top-right-radius:50%}.rmdp-rtl .rmdp-range-hover.end:not(.force),.rmdp-rtl .rmdp-range.end:not(.force){border-bottom-left-radius:50%;border-bottom-right-radius:unset;border-top-left-radius:50%;border-top-right-radius:unset}.rmdp-rtl .rmdp-range.start.end:not(.force){border-radius:50%}.rmdp-rtl .rmdp-ym .rmdp-range-hover.start:not(.force),.rmdp-rtl .rmdp-ym .rmdp-range.start:not(.force){border-bottom-right-radius:15px;border-top-right-radius:15px}.rmdp-rtl .rmdp-ym .rmdp-range-hover.end:not(.force),.rmdp-rtl .rmdp-ym .rmdp-range.end:not(.force){border-bottom-left-radius:15px;border-top-left-radius:15px}.rmdp-day-hidden,.rmdp-day.rmdp-disabled{cursor:default}.rmdp-selected .highlight{box-shadow:0 0 3px #8798ad}.rmdp-day:not(.rmdp-disabled):not(.rmdp-day-hidden) .highlight-red:hover{background-color:#ff6687}.rmdp-day:not(.rmdp-deactive) .highlight-red{color:#cc0303}.rmdp-day.rmdp-deactive .highlight-red{color:#e08e8e}.rmdp-day.rmdp-selected .highlight-red{background-color:#ea0034;color:#fff}.rmdp-day.rmdp-deactive.rmdp-selected .highlight-red{background-color:#e4b0ba;color:#fff}.rmdp-day:not(.rmdp-disabled):not(.rmdp-day-hidden) .highlight-green:hover{background-color:#4db6ac}.rmdp-day:not(.rmdp-deactive) .highlight-green{color:#00796b}.rmdp-day.rmdp-deactive .highlight-green{color:#7ab3ac}.rmdp-day.rmdp-selected .highlight-green{background-color:#009688;color:#fff}.rmdp-day.rmdp-deactive.rmdp-selected .highlight-green{background-color:#749c98;color:#fff}.rmdp-day-hidden,.rmdp-day-hidden:hover span{background-color:unset;color:transparent}.rmdp-month-name{cursor:default;font-size:14px;margin:3px 0}.rmdp-full-year{grid-template-columns:1fr 1fr 1fr}@media (max-height:450px),(max-width:450px){.rmdp-day,.rmdp-week-day{height:28px;width:28px}.rmdp-day span{font-size:12px;padding-left:.5px}.only.rmdp-month-picker,.only.rmdp-year-picker{height:200px;width:230px}.rmdp-header{padding:3px 0 0}.rmdp-header,.rmdp-month-name{font-size:12px}.rmdp-full-year{grid-template-columns:1fr 1fr}}");
var H = ["datePickerProps", "DatePicker"];
function q(r, t) {
  var n,
    o = r.value,
    d = r.calendar,
    u = r.locale,
    p = r.format,
    m = r.onlyMonthPicker,
    h = r.onlyYearPicker,
    y = r.range,
    v = void 0 !== y && y,
    b = r.multiple,
    x = void 0 !== b && b,
    w = r.className,
    k = r.role,
    D = r.weekDays,
    O = r.months,
    E = r.children,
    M = r.onChange,
    A = r.showOtherDays,
    R = r.minDate,
    L = r.maxDate,
    F = r.mapDays,
    W = r.disableMonthPicker,
    B = r.disableYearPicker,
    z = r.formattingIgnoreList,
    q = r.onReady,
    J = r.onlyShowInRangeDates,
    U = void 0 === J || J,
    $ = r.zIndex,
    G = void 0 === $ ? 100 : $,
    Q = r.plugins,
    X = void 0 === Q ? [] : Q,
    Z = r.sort,
    ee = r.numberOfMonths,
    re = void 0 === ee ? 1 : ee,
    te = r.currentDate,
    ne = r.digits,
    ae = r.buttons,
    oe = void 0 === ae || ae,
    ie = r.renderButton,
    de = r.weekStartDayIndex,
    le = void 0 === de ? 0 : de,
    ue = r.disableDayPicker,
    ce = r.onPropsChange,
    se = r.onMonthChange,
    fe = r.onYearChange,
    pe = r.onFocusedDateChange,
    me = r.readOnly,
    he = r.disabled,
    ye = r.hideMonth,
    ge = r.hideYear,
    ve = r.hideWeekDays,
    be = r.shadow,
    xe = void 0 === be || be,
    we = r.fullYear,
    ke = r.displayWeekNumbers,
    De = r.weekNumber,
    Oe = r.weekPicker,
    Ee = r.rangeHover,
    Ye = r.monthYearSeparator,
    Me = r.formatMonth,
    Pe = r.formatYear,
    Ne = r.highlightToday,
    Se = void 0 === Ne || Ne,
    Ce = r.headerOrder,
    Ie = void 0 === Ce ? ["LEFT_BUTTON", "MONTH_YEAR", "RIGHT_BUTTON"] : Ce,
    je = r.style,
    Te = void 0 === je ? {} : je;
  !te || te instanceof i.default || (console.warn("currentDate must be instance of DateObject"), te = void 0), ("number" != typeof le || le < 0 || le > 6) && (le = 0), ("number" != typeof re || re < 1 || h) && (re = 1), !(x || v || g(o)) || v || x || (x = !0), Oe && (v = !0, x = !1), we && (re = 12, m = !1, h = !1), h && !ye && (ye = !0);
  var Ae = f(V(d, u), 2);
  d = Ae[0], u = Ae[1], p = j(m, h, p), z = N(z), F = [].concat(F).filter(Boolean), X = [].concat.apply([], X);
  var Re = f(e.useState({}), 2),
    Le = Re[0],
    Fe = Re[1],
    Ve = {},
    We = e.useRef({
      mustCallOnReady: !0,
      currentDate: te
    });
  e.useEffect(function () {
    Fe(function (e) {
      var r = We.current.currentDate,
        t = e.date,
        n = e.selectedDate,
        a = e.initialValue,
        c = e.focused,
        s = e.mustSortDates;
      function f(e) {
        if (e) return e.calendar.name !== d.name && e.setCalendar(d), e.locale.name !== u.name && e.setLocale(u), e._format !== p && e.setFormat(p), e.digits = ne, e.ignoreList = JSON.parse(z), e;
      }
      function y(e) {
        return new i.default(r || e);
      }
      if (o) {
        if (g(n = K(o, d, u, p))) t || (t = y(n.flat()[0]));else if (t && 1 !== re) {
          var b = new i.default(t).toFirstOfMonth(),
            w = new i.default(t).add(re - 1, m ? "years" : "months").toLastOfMonth();
          (n < b || n > w) && (t = new i.default(n));
        } else t = y(n);
      } else t || (t = y({
        calendar: d,
        locale: u,
        format: p
      })), a && (n = void 0);
      if ([].concat(n).flat().forEach(f), f(t), x || v || g(o)) {
        if (n || (n = []), g(n) || (n = x && v ? [[n]] : [n]), v && !x && n.length > 2) {
          var k = n[n.length - 1];
          n = [n[0], k], c = k;
        }
        x && !v && Z && !s ? (s = !0, n.sort(function (e, r) {
          return e - r;
        })) : v && !x && n.sort(function (e, r) {
          return e - r;
        });
      } else g(n) && (n = n.flat()[n.length - 1]);
      return we && t.toFirstOfYear(), delete We.current.currentDate, l(l({}, e), {}, {
        date: t,
        selectedDate: n,
        multiple: x,
        range: v,
        onlyMonthPicker: m,
        onlyYearPicker: h,
        initialValue: e.initialValue || o,
        value: o,
        focused: c,
        calendar: d,
        locale: u,
        format: p,
        mustSortDates: s,
        year: t.year,
        today: f(e.today) || new i.default({
          calendar: d
        }),
        weekPicker: Oe
      });
    });
  }, [o, d, u, p, m, h, v, x, Z, re, ne, z, we, Oe]), e.useEffect(function () {
    (R || L) && Fe(function (e) {
      var r = e.calendar,
        t = e.locale,
        n = e.format,
        a = function (e, r, t, n, a) {
          r && (r = T(r, n, a).set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
          }));
          t && (t = T(t, n, a).set({
            hour: 23,
            minute: 59,
            second: 59,
            millisecond: 999
          }));
          g(e) && (e = e.filter(function (e) {
            return !(r && e < r) && !(t && e > t);
          }));
          return [e, r, t];
        }(K(o, r, t, n), R, L, r, n),
        i = f(a, 3),
        d = i[0],
        u = i[1],
        c = i[2];
      return l(l({}, e), {}, {
        inRangeDates: U ? d : e.selectedDate,
        minDate: u,
        maxDate: c
      });
    });
  }, [R, L, U, o]), Le.today && !We.current.isReady && (We.current.isReady = !0), e.useEffect(function () {
    We.current.isReady && We.current.mustCallOnReady && q instanceof Function && (We.current.mustCallOnReady = !1, q());
  }, [We.current.isReady, q]);
  var Be = "rmdp-top-class " + Ze(["top", "bottom"]),
    _e = {
      top: [],
      bottom: [],
      left: [],
      right: []
    },
    ze = _(null === (n = Le.date) || void 0 === n ? void 0 : n.locale),
    He = {
      state: Le,
      setState: Fe,
      onChange: $e,
      sort: Z,
      handleFocusedDate: Qe,
      isRTL: ze,
      fullYear: we,
      monthAndYears: function () {
        var e = Le.date;
        if (!e) return [];
        for (var r = [], t = [], n = e.digits, a = 0; a < re; a++) {
          var o = void 0,
            i = e.year,
            d = e.monthIndex + a;
          if (m && (i += a), d > 11 && (d -= 12, m || i++), g(O) && O.length >= 12) {
            var l = O[d];
            o = g(l) ? l[0] : l;
          } else o = e.months[d].name;
          i = C(i.toString(), n), r.push(o), t.push(i);
        }
        return [r, t];
      }(),
      rangeHover: Ee,
      highlightToday: Se,
      numberOfMonths: re
    },
    qe = arguments[0],
    Je = qe.datePickerProps,
    Ke = qe.DatePicker,
    Ue = s(qe, H);
  return function () {
    if (!We.current.isReady || !g(X)) return;
    var r = {
        state: Le,
        setState: Fe,
        registerListener: er,
        calendarProps: Ue,
        datePickerProps: Je,
        handleChange: $e,
        Calendar: We.current.Calendar,
        DatePicker: Ke,
        handlePropsChange: Ge,
        handleFocusedDate: function (e) {
          return Qe(e);
        },
        minDate: R,
        maxDate: L
      },
      t = function (e) {
        return ue ? "bottom" : e.props.position || "right";
      };
    X.forEach(function (n, a) {
      if ("string" != typeof n.type) {
        var o = {},
          i = t(n);
        if (_e[i] && !n.props.disabled) {
          for (var d = 0; d < X.length; d++) if ("string" != typeof X[d].type && !X[d].props.disabled) {
            if (4 === Object.keys(o).length) break;
            var u = t(X[d]);
            ["top", "bottom"].includes(i) ? (u === i && d > a && (o.bottom = !0), u === i && d < a && (o.top = !0)) : (Be.includes("border-top") && (o.top = !0), Be.includes("border-bottom") && (o.bottom = !0), u === i && d > a && (o.right = !0), u === i && d < a && (o.left = !0));
          }
          _e[i].push(e.cloneElement(n, l({
            key: a,
            position: i,
            nodes: o
          }, r)));
        }
      } else "mapDays" === n.type && F.push(n.fn(r));
    });
  }(), Le.today ? a.default.createElement("div", {
    ref: function (e) {
      e && (e.date = Le.date, e.set = function (e, r) {
        he || Fe(l(l({}, Le), {}, {
          date: new i.default(Le.date.set(e, r))
        }));
      });
      if (We.current.Calendar = e, t instanceof Function) return t(e);
      t && (t.current = e);
    },
    role: k || "dialog",
    className: "rmdp-wrapper rmdp-".concat(xe ? "shadow" : "border", " ").concat(w || ""),
    style: l({
      zIndex: G
    }, Te)
  }, _e.top, a.default.createElement("div", {
    style: {
      display: "flex"
    },
    className: Be
  }, _e.left, !ue && a.default.createElement("div", {
    className: "rmdp-calendar ".concat(ze ? "rmdp-rtl" : "", " ").concat(Ze(["left", "right"]))
  }, a.default.createElement(P, l(l({}, He), {}, {
    disableYearPicker: B,
    disableMonthPicker: W,
    buttons: oe,
    renderButton: ie,
    handleMonthChange: Xe,
    disabled: he,
    hideMonth: ye,
    hideYear: ge,
    monthYearSeparator: Ye,
    formatMonth: Me,
    formatYear: Pe,
    headerOrder: Ie
  })), a.default.createElement("div", {
    style: {
      position: "relative"
    }
  }, a.default.createElement(Y, l(l({}, He), {}, {
    showOtherDays: A,
    mapDays: F,
    onlyShowInRangeDates: U,
    customWeekDays: D,
    weekStartDayIndex: le,
    hideWeekDays: ve,
    displayWeekNumbers: ke,
    weekNumber: De
  })), !we && a.default.createElement(a.default.Fragment, null, !W && a.default.createElement(S, c({}, He, {
    customMonths: O,
    handleMonthChange: Xe
  })), !B && a.default.createElement(I, c({}, He, {
    onYearChange: fe
  }))))), _e.right), _e.bottom, E) : null;
  function $e(e, r) {
    if (e instanceof i.default && (e = new i.default(e)), !he) {
      if (e || null === e) {
        if (me) return;
        Ve.change && Ve.change.forEach(function (r) {
          return r(e);
        });
      }
      if (e || null === e) {
        var t = null == M ? void 0 : M(e);
        r && !1 !== t && Fe(r);
      } else r && Fe(r);
      Ge({
        value: e
      });
    }
  }
  function Ge() {
    var e,
      r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    if (!me && !he) {
      var t = l(l(l(l({}, Ue), Je), r), {}, {
        value: null !== (e = r.value) && void 0 !== e ? e : Le.selectedDate
      });
      delete t.onPropsChange, null == ce || ce(t);
    }
  }
  function Qe(e, r) {
    me || he || null == pe || pe(e, r);
  }
  function Xe(e) {
    null == se || se(e);
  }
  function Ze(e) {
    return ue || !g(X) ? "" : Array.from(new Set(X.map(function (r) {
      if (!r.props) return "";
      var t = r.props.position || "right";
      return e.includes(t) && !r.props.disabled ? "rmdp-border-" + t : "";
    }))).join(" ");
  }
  function er(e, r) {
    Ve[e] || (Ve[e] = []), Ve[e].push(r);
  }
}
var J = e.forwardRef(q);
function K(e, r, t, n) {
  var a = [].concat(e).map(function (e) {
    return g(e) ? e.map(o).filter(d) : o(e);
  }).filter(d);
  return g(e) ? a : a.flat()[0];
  function o(e) {
    return e ? e instanceof i.default ? e : new i.default({
      date: e,
      calendar: r,
      locale: t,
      format: n
    }) : {};
  }
  function d(e) {
    return g(e) || e.isValid;
  }
}
z('.rmdp-visible{visibility:visible}.rmdp-invisible{visibility:hidden}.rmdp-input{border:1px solid #c0c4d6;border-radius:5px;height:22px;margin:1px 0;padding:2px 5px}.rmdp-input:focus{border:1px solid #a4b3c5;box-shadow:0 0 2px #a4b3c5;outline:none!important}.rmdp-button{background-color:#0074d9;border:none;border-radius:5px;color:#fff;cursor:pointer;display:inline-block;padding:7px 16px;text-align:center;text-decoration:none;transition:.3s}.rmdp-button:hover{background-color:#143ac5;transition:.4s}.rmdp-button:disabled{background-color:#8798ad}.rmdp-action-button{border-radius:unset;color:#2682d3;float:right;font-weight:700;margin:15px 10px 15px 0}.rmdp-action-button,.rmdp-action-button:hover{background-color:transparent}.rmdp-ep-arrow{overflow:hidden;will-change:transform}.rmdp-ep-arrow:after{background-color:#fff;content:"";height:12px;position:absolute;transform:rotate(45deg);width:12px}.rmdp-ep-shadow:after{box-shadow:0 0 6px #8798ad}.rmdp-ep-border:after{border:1px solid #cfd8e2}.rmdp-ep-arrow[direction=top]{border-bottom:1px solid #fff}.rmdp-ep-arrow[direction=left]{border-right:1px solid #fff}.rmdp-ep-arrow[direction=right]{border-left:1px solid #fff;margin-left:-1px}.rmdp-ep-arrow[direction=bottom]{border-top:1px solid #fff;margin-top:-1.5px}.rmdp-ep-arrow[direction=top]:after{left:4px;top:5px}.rmdp-ep-arrow[direction=bottom]:after{left:4px;top:-6px}.rmdp-ep-arrow[direction=left]:after{left:5px;top:3px}.rmdp-ep-arrow[direction=right]:after{left:-6px;top:3px}');
var U = ["value", "calendar", "locale", "format", "onlyMonthPicker", "onlyYearPicker", "onChange", "range", "multiple", "name", "id", "title", "placeholder", "required", "style", "className", "inputClass", "disabled", "render", "weekDays", "months", "children", "inputMode", "scrollSensitive", "hideOnScroll", "minDate", "maxDate", "formattingIgnoreList", "containerClassName", "calendarPosition", "editable", "onOpen", "onClose", "arrowClassName", "zIndex", "arrow", "fixMainPosition", "onPositionChange", "onPropsChange", "digits", "readOnly", "shadow", "onFocusedDateChange", "type", "weekPicker", "mobileLabels", "onOpenPickNewDate", "mobileButtons", "dateSeparator", "multipleRangeSeparator", "typingTimeout"],
  $ = ["label"];
function G(r, t) {
  var n = r.value,
    d = r.calendar,
    u = r.locale,
    p = r.format,
    m = r.onlyMonthPicker,
    h = r.onlyYearPicker,
    v = r.onChange,
    b = r.range,
    x = void 0 !== b && b,
    w = r.multiple,
    k = void 0 !== w && w,
    D = r.name,
    O = r.id,
    E = r.title,
    Y = r.placeholder,
    M = r.required,
    P = r.style,
    S = void 0 === P ? {} : P,
    I = r.className,
    A = void 0 === I ? "" : I,
    R = r.inputClass,
    L = r.disabled,
    F = r.render,
    W = r.weekDays,
    z = r.months,
    H = r.children,
    q = r.inputMode,
    K = r.scrollSensitive,
    G = void 0 === K || K,
    Q = r.hideOnScroll,
    ee = r.minDate,
    re = r.maxDate,
    te = r.formattingIgnoreList,
    ne = r.containerClassName,
    ae = void 0 === ne ? "" : ne,
    oe = r.calendarPosition,
    ie = void 0 === oe ? "bottom-left" : oe,
    de = r.editable,
    le = void 0 === de || de,
    ue = r.onOpen,
    ce = r.onClose,
    se = r.arrowClassName,
    fe = void 0 === se ? "" : se,
    pe = r.zIndex,
    me = void 0 === pe ? 100 : pe,
    he = r.arrow,
    ye = void 0 === he || he,
    ge = r.fixMainPosition,
    ve = r.onPositionChange,
    be = r.onPropsChange,
    xe = r.digits,
    we = r.readOnly,
    ke = r.shadow,
    De = void 0 === ke || ke,
    Oe = r.onFocusedDateChange,
    Ee = r.type,
    Ye = r.weekPicker,
    Me = r.mobileLabels,
    Pe = r.onOpenPickNewDate,
    Ne = void 0 === Pe || Pe,
    Se = r.mobileButtons,
    Ce = void 0 === Se ? [] : Se,
    Ie = r.dateSeparator,
    je = r.multipleRangeSeparator,
    Te = void 0 === je ? "," : je,
    Ae = r.typingTimeout,
    Re = void 0 === Ae ? 700 : Ae,
    Le = s(r, U),
    Fe = f(e.useState(), 2),
    Ve = Fe[0],
    We = Fe[1],
    Be = f(e.useState(), 2),
    _e = Be[0],
    ze = Be[1],
    He = f(e.useState(""), 2),
    qe = He[0],
    Je = He[1],
    Ke = f(e.useState(!1), 2),
    Ue = Ke[0],
    $e = Ke[1],
    Ge = f(e.useState(!1), 2),
    Qe = Ge[0],
    Xe = Ge[1],
    Ze = e.useRef(),
    er = e.useRef(),
    rr = e.useRef(),
    tr = e.useRef({
      isTyping: !1
    }),
    nr = Ie || (x || Ye ? " ~ " : ", "),
    ar = arguments[0],
    or = "string" == typeof A && A.includes("rmdp-mobile"),
    ir = e.useCallback(function () {
      if (!1 !== (null == ce ? void 0 : ce())) {
        var e = Z(er);
        if (e && e.forEach(function (e) {
          return e.blur();
        }), tr.current.mobile) {
          var r = rr.current.parentNode.parentNode;
          r.classList.remove("rmdp-calendar-container-mobile"), r.style.position = "absolute", r.style.visibility = "hidden";
        }
        void 0 !== tr.current.validInputValue && (Je(tr.current.validInputValue), tr.current.validInputValue = void 0), $e(!1), Xe(!1);
      }
    }, [ce]),
    dr = [{
      type: "button",
      className: "rmdp-button rmdp-action-button",
      onClick: function () {
        ze(void 0), ir();
      },
      label: cr("CANCEL")
    }, {
      type: "button",
      className: "rmdp-button rmdp-action-button",
      onClick: function () {
        _e && (pr(_e, !0), ze(void 0)), ir();
      },
      label: cr("OK")
    }];
  or && !tr.current.mobile && (tr.current = l(l({}, tr.current), {}, {
    mobile: !0
  })), !or && tr.current.mobile && (tr.current = l(l({}, tr.current), {}, {
    mobile: !1
  })), te = N(te), p = j(m, h, p);
  var lr,
    ur = f(V(d, u), 2);
  return d = ur[0], u = ur[1], e.useEffect(function () {
    function e(e) {
      if (Ue && !tr.current.mobile) {
        var r = [];
        if ([er.current, rr.current].forEach(function (t) {
          var n, a;
          !t || t.contains(e.target) || e.target.classList.contains("b-deselect") || null !== (n = e.target.parentNode) && void 0 !== n && null !== (n = n.classList) && void 0 !== n && null !== (a = n.contains) && void 0 !== a && a.call(n, "b-deselect") || r.push(t);
        }), 2 === r.length) return ir();
        rr.current && rr.current.contains(e.target) && (Ze.current.removeTransition(), Ze.current.refreshPosition());
      }
    }
    function r() {
      Q && Ue && ir();
    }
    return document.addEventListener("click", e, !1), document.addEventListener("scroll", r, !0), function () {
      document.removeEventListener("click", e, !1), document.removeEventListener("scroll", r, !0);
    };
  }, [ir, t, Ue, Q]), e.useEffect(function () {
    var e = n,
      r = tr.current,
      t = r.date,
      a = r.initialValue,
      o = function () {
        return e[e.length - 1];
      };
    function c(e) {
      if (e) return e instanceof i.default || (e = new i.default({
        date: e,
        calendar: d,
        locale: u,
        format: p
      })), e.calendar !== d && e.setCalendar(d), e.set({
        weekDays: W,
        months: z,
        digits: xe,
        locale: u,
        format: p,
        ignoreList: JSON.parse(te)
      }), e;
    }
    n || a || !t ? a && !n && (a = void 0) : e = t;
    var s = "";
    if (x || k || g(e)) {
      var m = function (e) {
        return e = e.map(c).filter(function (e) {
          return void 0 !== e;
        }), x && e.length > 2 && (e = [e[0], o()]), [e, X(e, nr)];
      };
      if (g(e) || (e = x && k ? e ? [[e]] : [] : [e]), k && x) e = e.map(function (r, t) {
        var n = f(m(g(r) ? r : [r]), 2),
          a = n[0],
          o = n[1];
        return s += o + (t < e.length - 1 ? " ".concat(Te, " ") : ""), a;
      });else {
        var h = f(m(e), 2);
        e = h[0], s = h[1];
      }
      s = s.toString().replace(/\s,\s$/, "");
    } else g(e) && (e = o()), (e = c(e)) && (s = e.format());
    tr.current.isTyping || Je(s), tr.current = l(l({}, tr.current), {}, {
      date: e,
      separator: nr,
      initialValue: a || n
    }), tr.current.mobile && Ze.current.isOpen ? ze(e) : We(e);
  }, [n, d, u, p, x, k, nr, m, h, W, z, xe, te]), e.useEffect(function () {
    var e = tr.current.selection;
    if (e) {
      var r = Z(er);
      0 !== r.length && (r.forEach(function (r) {
        document.activeElement === r && (r.setSelectionRange(e, e), tr.current.selection = void 0);
      }), Ze.current.refreshPosition());
    }
  }, [qe]), (k || x || g(Ve) || !le) && (q = "none"), a.default.createElement(o.default, c({
    ref: function (e) {
      e && (e.openCalendar = function () {
        return setTimeout(function () {
          return sr();
        }, 10);
      }, e.closeCalendar = ir, e.isOpen = Ue && Qe);
      if (Ze.current = e, t instanceof Function) return t(e);
      t && (t.current = e);
    },
    element: F ? a.default.createElement("div", {
      ref: er
    }, e.isValidElement(F) ? e.cloneElement(F, {
      value: qe,
      openCalendar: sr,
      onFocus: sr,
      handleValueChange: mr,
      onChange: mr,
      locale: u,
      separator: nr
    }) : F instanceof Function ? F(qe, sr, mr, u, nr) : null) : a.default.createElement("input", {
      ref: er,
      type: Ee || "text",
      name: D,
      id: O,
      title: E,
      required: M,
      onFocus: sr,
      className: R || "rmdp-input",
      placeholder: Y,
      value: qe,
      onChange: mr,
      style: S,
      autoComplete: "off",
      disabled: !!L,
      inputMode: q || (or ? "none" : void 0),
      readOnly: we
    }),
    popper: Ue && a.default.createElement(J, c({
      ref: rr,
      value: _e || Ve,
      onChange: pr,
      range: x,
      multiple: k,
      calendar: d,
      locale: u,
      format: p,
      onlyMonthPicker: m,
      onlyYearPicker: h,
      className: A + (or ? " rmdp-mobile" : ""),
      weekDays: W,
      months: z,
      digits: xe,
      minDate: ee,
      maxDate: re,
      formattingIgnoreList: JSON.parse(te),
      onPropsChange: be,
      shadow: De,
      onReady: hr,
      DatePicker: Ze.current,
      datePickerProps: ar,
      onFocusedDateChange: yr,
      weekPicker: Ye
    }, Le), H, or && (lr = [].concat.apply([], ar.plugins || []).some(function (e) {
      var r = e.props;
      return !(void 0 === r ? {} : r).disabled;
    }), g(Ce) && a.default.createElement("div", {
      className: "rmdp-action-buttons ".concat(_(u) ? "rmdp-rtl" : "", " ").concat(lr ? "rmdp-border-top" : "")
    }, Ce.concat(dr).map(function (e, r) {
      var t = e.label,
        n = s(e, $);
      return a.default.createElement("button", c({
        key: r
      }, n), t);
    })))),
    active: !or && Qe,
    position: ie,
    arrow: !or && ye,
    fixMainPosition: !G || ge,
    zIndex: me,
    onChange: !or && ve,
    containerClassName: "rmdp-container ".concat(ae),
    arrowClassName: ["rmdp-ep-arrow", "rmdp-ep-".concat(De ? "shadow" : "border"), A, fe].join(" ")
  }, Le));
  function cr(e) {
    var r,
      t = u || new i.default().locale;
    if ("string" != typeof t.name) return e;
    return (null == Me ? void 0 : Me[e]) || (null === (r = {
      en: {
        OK: "OK",
        CANCEL: "CANCEL"
      },
      fa: {
        OK: "تأیید",
        CANCEL: "لغو"
      },
      ar: {
        OK: "تأكيد",
        CANCEL: "الغاء"
      },
      hi: {
        OK: "पुष्टि",
        CANCEL: "रद्द करें"
      }
    }[B(t)]) || void 0 === r ? void 0 : r[e]) || e;
  }
  function sr() {
    if (!L && !we && !1 !== (null == ue ? void 0 : ue())) {
      if (Ne && !n && !tr.current.date && !x && !k && !or) {
        var e = new i.default({
          calendar: d,
          locale: u,
          format: p,
          months: z,
          weekDays: W,
          digits: xe,
          ignoreList: JSON.parse(te)
        });
        (!ee || e > T(ee, d, p)) && (!re || e < T(re, d, p)) && (pr(e), null == be || be(l(l({}, ar), {}, {
          value: e
        })), tr.current.date = e);
      }
      var r = Z(er);
      or && r.length > 0 && r.forEach(function (e) {
        return e.blur();
      }), r.length > 0 || !Ue ? $e(!0) : ir();
    }
  }
  function fr(e) {
    var r = "";
    return e && (r = k && x && g(e) ? e.map(function (e) {
      return X(e, nr);
    }).join(" ".concat(Te, " ")) : X(e, nr)), r;
  }
  function pr(e, r, t) {
    if (or && !r) return ze(e);
    var a = fr(e),
      o = t || a.toString().replace(/\s,\s$/, "");
    return e && [].concat(e).flat().some(function (e) {
      return ee && e < T(ee, d, p) || re && e > T(re, d, p);
    }) ? (tr.current.validInputValue = fr(n || tr.current.date), Je(o)) : (tr.current.validInputValue = a, !1 === (null == v ? void 0 : v(e, {
      validatedValue: a,
      input: er.current,
      isTyping: !!t
    })) ? (Je(qe), !1) : (We(e), Je(o), void (tr.current = l(l({}, tr.current), {}, {
      date: e
    }))));
  }
  function mr(e) {
    if (le) {
      tr.current.isTyping = !0, setTimeout(function () {
        tr.current.isTyping = !1;
      }, Re), tr.current.selection = e.target.selectionStart;
      var r = e.target.value,
        t = {
          calendar: d,
          locale: u,
          format: p,
          ignoreList: JSON.parse(te)
        };
      if (xe = g(xe) ? xe : u.digits, !r) return Je(""), pr(null);
      if (xe) {
        var n,
          a,
          o = y(xe);
        try {
          for (o.s(); !(n = o.n()).done;) {
            var c = n.value;
            r = r.replace(new RegExp(c, "g"), xe.indexOf(c));
          }
        } catch (e) {
          o.e(e);
        } finally {
          o.f();
        }
        a = g(Ve) ? k && x ? (r || "").split(Te).filter(Boolean).map(f) : f(r) : s(r), pr(g(Ve) || a.isValid ? a : null, void 0, C(r, xe));
      }
    }
    function s(e) {
      return /(?=.*Y)(?=.*M)(?=.*D)/.test(p) ? new i.default(l(l({}, t), {}, {
        date: e
      })) : new i.default(t).parse(e);
    }
    function f(e) {
      return (e || "").split(nr).filter(Boolean).map(function (e) {
        return s(e.trim());
      });
    }
  }
  function hr() {
    if (Xe(!0), or) {
      var e = rr.current.parentNode.parentNode;
      e.className = "rmdp-calendar-container-mobile", e.style.position = "fixed", e.style.transform = "", setTimeout(function () {
        e.style.visibility = "visible";
      }, 50);
    }
  }
  function yr(e, r) {
    g(tr.current.date) || !r || or || ir(), null == Oe || Oe(e, r);
  }
}
var Q = e.forwardRef(G);
function X(e, r) {
  var t = [].concat(e).map(function (e) {
    return null != e && e.isValid ? e.format() : "";
  });
  return t.toString = function () {
    return this.filter(Boolean).join(r);
  }, t;
}
function Z(e) {
  return e.current ? "INPUT" === e.current.tagName ? [e.current] : Array.from(e.current.querySelectorAll("input")) : [];
}
Object.defineProperty(exports, "DateObject", {
  enumerable: !0,
  get: function () {
    return i.default;
  }
}), exports.Calendar = J, exports.default = Q, exports.getAllDatesInRange = function () {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
    r = arguments.length > 1 ? arguments[1] : void 0;
  if (!Array.isArray(e)) return [];
  var t = e[0],
    n = e[e.length - 1],
    a = [];
  if (!(t instanceof i.default && n instanceof i.default && t.isValid && n.isValid && !(t > n))) return [];
  for (t = new i.default(t), n = new i.default(n); t <= n; t.day++) a.push(r ? t.toDate() : new i.default(t));
  return a;
}, exports.toDateObject = T;